import { Injectable } from '@angular/core';
import { BaseService, httpOptions} from '@core/service/base.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ConfigParaDtService } from '../basic-data/srm-config/config-info/service/config-para-dt.service';
import {BrowseConfig} from "@core/bean/browse-config";

@Injectable({
  providedIn: 'root'
})
export class SoaService extends BaseService{

    private soaSource  = new Subject<any>();

  soa:any = {

    companyCode:null,

    supplierCode:null,
    plant:{},
    soaDtList:[],
    perliteToPc:[],
    claimStatus:null
  };

  private url = "api/soa";

  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(){
    return this.url;
  }

  /**
   * 获取workflowId
   */
  getWorkflowId():Observable<any> {
    const url = this.getUrl()+"/workflowId";
    return this.http.get<any>(url).pipe(
      tap(_ => this.log("Get workflowId")),
        catchError(this.handleError<any>("Get workflowId"))
    );
  }

  /**
   * 获取所有相关流程节点
   */
  getNodes():Observable<any> {
    const url = this.getUrl()+"/getNodes";
    return this.http.get<any>(url).pipe(
      tap(_ => this.log("Get workflowId")),
      catchError(this.handleError<any>("Get workflowId"))
    );
  }

  /**
   * 获取对账开票申请
   */
  getBills(object:any):Observable<any> {
    const url = `${this.getUrl()}/application-bills`;
    return this.http.post<any>(url, object, httpOptions).pipe(
      tap((object:any) => this.log(`added object =${object}`)),
      catchError(this.handleError<any>('addany'))
    );
  }

  //再次同步到sap
  saveSoaToSap(object:any):Observable<any> {
    const url = `${this.getUrl()}/saveSoaToSap`;
    return this.http.post<any>(url, object, httpOptions).pipe(
      tap((object:any) => this.log(`added object =${object}`)),
      catchError(this.handleError<any>('addany'))
    );
  }

  //sap同步到本地数据
  saveSapToSoa(object:any):Observable<any> {
    const url = `${this.getUrl()}/saveSapToSoa`;
    return this.http.post<any>(url, object, httpOptions).pipe(
      tap((object:any) => this.log(`added object =${object}`)),
      catchError(this.handleError<any>('addany'))
    );
  }

  getRelateCompact(id:number):Observable<any> {
    const url = this.getUrl()+"/getRelateCompact/"+id;

    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`fetched object id=${id}`)),
      catchError(this.handleError<any>(`getany id=${id}`))
    );

  }

  getZhejiangProvincialOffice(billcode:String,invoiceCode:String):Observable<any> {
    const url = this.getUrl()+"/selectZhejiangProvincialOffice/"+billcode+"/"+invoiceCode;

    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`fetched object id=${billcode}`)),
      catchError(this.handleError<any>(`getany id=${billcode}`))
    );

  }

    public open(config:BrowseConfig, onOk, onCancel?) {
        this.soaSource.next({
            config: config,
            onOk: onOk,
            onCancel: onCancel,
        });
    }


  selectInvoicesFromPsb(beginInvoiceDate: string, endInvoiceDate: string, sellerName: string, page: number, size: number, randomUuid: string, soaNo: string, companyName: string): Observable<any> {
    const url = this.getUrl() + "/selectInvoicesFromPsb";
    let params = new HttpParams()
      .set('beginInvoiceDate', beginInvoiceDate)
      .set('endInvoiceDate', endInvoiceDate)
      .set('sellerName', sellerName)
      .set('soaNo', soaNo)
      .set('companyName', companyName)
      .set('pageIndex', page.toString())
      .set('pageSize', size.toString());
    if (randomUuid != null) {
      params = params.set('randomUuid', randomUuid);
    }
    return this.http.get<any>(url, {params, observe: 'response'});
  }

  releaseLock(ids: string[]): Observable<any> {
    const url = this.getUrl() + "/releaseLock";
    let params = new HttpParams()
      .set('ids', ids.join(',')); // 使用 join() 方法将数组转为字符串;
    return this.http.get<any>(url, {params, observe: 'response'});
  }

  bindingInvoice(dataList: any[], soaNo: string): Observable<any> {
    const url = this.getUrl() + "/bindingInvoice";
    let params = new HttpParams()
      .set('soaNo', soaNo);
    return this.http.post<any>(url, dataList, {params, observe: 'response'});
  }

  deleteSelectedInvoice(dataList: any[], soaNo: string): Observable<any> {
    const url = this.getUrl() + "/deleteSelectedInvoice";
    let params = new HttpParams()
      .set('soaNo', soaNo);
    return this.http.post<any>(url, dataList, {params, observe: 'response'});
  }

  deleteAllInvoice(soaNo: string): Observable<any> {
    const url = `${this.getUrl()}/deleteAllInvoice?soaNo=${soaNo}`;
    return this.http.post<any>(url, {}, {observe: 'response'});
  }

  selectBoundInvoice(soaNo: string): Observable<any> {
    const url = `${this.getUrl()}/selectBoundInvoice?soaNo=${soaNo}`;
    return this.http.post<any>(url, {}, {observe: 'response'});
  }


}
